<div class="view-enter-animation w-full">
  <div class="mobi-ui-grid is-centered mobi-ui-margin-t-md">
    <div
      class="max-w-full mobi-ui-col-1/1 xl:mobi-ui-col-3/4 mobi-ui-animation-appear-up-init mobi-ui-animation-appear-up-render is-delayed-300"
    >
      <div class="mobi-ui-grid !items-center justify-between mobi-ui-margin-y-md">
        <div
          class="mobi-ui-col-1/1 sm:mobi-ui-col-1/2 md:mobi-ui-col-2/3 xl:mobi-ui-col-1/2"
        >
          @if (rating()) {
            <mobi-star-rating
              [rating]="rating()!.average_rating"
              [starSize]="8"
            ></mobi-star-rating>
          }

          <h1 class="text-animation !pt-0 mobi-ui-padding-b-lg">
            {{ entity().slogan }}
          </h1>
          @if (entity().lead) {
            <mobi-text
              class="mobi-ui-font-100 text-lead mobi-ui-padding-b-lg block"
              [data]="entity().lead!"
            />
          }
        </div>
        <div class="mobi-ui-col-1/1 sm:mobi-ui-col-1/2 md:mobi-ui-col-1/3">
          <a
            betterRouterLink="{{ selectedProduct().url | extractUrl }}"
            class="mobi-ui-link-block-major xs:hidden"
            tabindex="0"
          >
            <mobi-ui-icon-major
              class="mobi-ui-link-block-icon-major"
              name="right"
            ></mobi-ui-icon-major>
            <span class="mobi-ui-link-block-text-major">
              {{
                'moreProduct'
                  | texts: { context: 'frontend', default: 'Mehr zum Produkt erfahren' }
              }}</span
            >
          </a>

          <mobi-teaser
            class="xs:block view-enter-animation hidden"
            [published]="selectedProduct().published"
            [teaserTitle]="selectedProduct().teaserTitle"
            [teaserText]="selectedProduct().teaserText"
            [teaserImage]="selectedProduct().teaserImage"
            [teaserUrl]="selectedProduct().url | extractUrl"
            [secondaryActionUrl]="
              (selectedProduct().calculatorCta
                | extractUrl
                | calcUrl: (selectedProduct().calculatorCtaAuth | extractUrl)) ||
              (selectedProduct().consultationCta | extractUrl)
            "
            [secondaryActionTarget]="
              selectedProduct().calculatorCta?.options?.attributes?.target ||
              selectedProduct().consultationCta?.options?.attributes?.target
            "
            [secondaryActionText]="
              selectedProduct().calculatorCta?.title ||
              selectedProduct().consultationCta?.title
            "
            secondaryActionIcon="calculator"
            [bundle]="selectedProduct().bundle"
            teaserTitleStyle="h5"
            [trackingId]="selectedProduct().uuid"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="page-content">
    <mobi-content-section width="sm" [content]="content">
      <ng-template #content>
        @defer (hydrate on viewport) {
          <mobi-view
            [viewId]="entity().viewRef?.view?.id || 'prodrat'"
            [display]="entity().viewRef?.view?.display || 'block_1'"
            [argument]="{ '0': entity().product.id }"
            [title]="entity().title"
            [includes]="['field_prorat_ga']"
            [results]="result"
          >
            <ng-template #result let-rows="rows">
              @for (row of rows(); track $index) {
                <div
                  tabindex="0"
                  class="p-4 border-t border-gray-200 last:border-b"
                  [class.cursor-pointer]="row.field_prorat_txt?.length"
                  [attr.aria-expanded]="isExpanded($index)"
                  [attr.aria-label]="getAriaLabel(row)"
                  (click)="toggleRow($index, $event)"
                  (keydown)="toggleRow($index, $event)"
                >
                  <div
                    role="region"
                    [attr.aria-label]="'Details for ' + row.field_prorat_ga.title"
                  >
                    <div class="flex justify-between items-start">
                      <mobi-star-rating
                        [rating]="row.field_prorat_rating"
                        [starSize]="4"
                        [showRatingNumber]="false"
                      ></mobi-star-rating>
                      @if (row.field_prorat_txt?.length) {
                        <mobi-ui-icon-major
                          name="plus"
                          class="mobi-ui-ink-grey transition-transform duration-300 pointer-events-none ml-4"
                          [class.rotate-90]="isExpanded($index)"
                        />
                      }
                    </div>

                    <h4 class="mobi-ui-text-inked mobi-ui-font-h4 !m-0">
                      {{ row.field_prorat_aname }}
                    </h4>

                    <p [class.mobi-ui-text-truncate]="!isExpanded($index)">
                      {{ row.field_prorat_txt }}
                    </p>
                    <span
                      class="mobi-ui-font-realist mobi-ui-font-h3 mobi-ui-font-bold mobi-ui-ink-grey mobi-ui-font-size-50 !m-0"
                    >
                      {{ formatDate(row.created) }}
                    </span>
                  </div>
                </div>
              }
            </ng-template>
          </mobi-view>
        }
      </ng-template>
    </mobi-content-section>
    <div class="content-section">
      <mobi-teaser
        class="block xs:hidden my-6 view-enter-animation"
        [published]="selectedProduct().published"
        [teaserTitle]="selectedProduct().teaserTitle"
        [teaserText]="selectedProduct().teaserText"
        [teaserImage]="selectedProduct().teaserImage"
        [teaserUrl]="selectedProduct().url | extractUrl"
        [secondaryActionUrl]="
          selectedProduct().calculatorCta
            | extractUrl
            | calcUrl: (selectedProduct().calculatorCtaAuth | extractUrl)
        "
        [secondaryActionTarget]="
          selectedProduct().calculatorCta?.options?.attributes?.target
        "
        [secondaryActionText]="selectedProduct().calculatorCta?.title"
        secondaryActionIcon="calculator"
        [bundle]="selectedProduct().bundle"
        teaserTitleStyle="h5"
        [trackingId]="selectedProduct().uuid"
      />
    </div>
  </div>
</div>
